// extracted by mini-css-extract-plugin
export default {"mainAbout":"About_mainAbout__KAmWP","top":"About_top__gkxwg","left":"About_left__8J1ks","right":"About_right__0SEhL"};